import type { IntegrationsContract } from '@terra/shared-contracts-integrations';
import type { TicketingProviderType } from '@terra/shared-contracts-knowledge-sync';
import { integrationsClient } from '@terra/shared-rest-clients-integrations';
import { tenantAwareApiWrapper, withOrchestratorClient } from './api-core';

export const ticketingIntegrationsApi = {
  getTicketingConnectionStatus: (provider: TicketingProviderType) =>
    tenantAwareApiWrapper<
      typeof IntegrationsContract.getTicketingConnectionStatus
    >({
      endpointFn: (headers) =>
        integrationsClient.getTicketingConnectionStatus({
          params: { provider },
          ...withOrchestratorClient(headers),
        }),
    }),
};
